import { DownOutlined } from '@ant-design/icons';
import { useState } from 'react';
import cs from 'classnames';
import Styles from '../../../Styles.module.scss';

export default function Logs() {
    const [expanded, setExpanded] = useState(false);

    return (
        <div className={Styles.CommandCard}>
            <div className={Styles.CommandHeader} onClick={() => setExpanded(!expanded)}>
                <div>
                    <span className={Styles.CommandName}>modelpark logs</span>
                    <span className={Styles.CommandSummary}>View app logs</span>
                </div>
                <DownOutlined className={cs(Styles.CommandExpandIcon, { [Styles.expanded]: expanded })} />
            </div>

            {expanded && (
                <div className={Styles.CommandBody}>
                    <p className={Styles.CommandDescription}>
                        View log output for a background app. By default, prints the last 100 lines.
                        Use <code>-f</code> to follow new output in real-time (like <code>tail -f</code>).
                        Press Ctrl+C to stop following.
                    </p>

                    <div className={Styles.CommandExample}>
                        <div className={Styles.CommandExampleLabel}>Options</div>
                        <table className={Styles.OptionsTable}>
                            <thead>
                                <tr>
                                    <th>Flag</th>
                                    <th>Default</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>-f, --follow</td>
                                    <td>false</td>
                                    <td>Follow log output</td>
                                </tr>
                                <tr>
                                    <td>-n, --lines</td>
                                    <td>100</td>
                                    <td>Number of lines to show</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className={Styles.CommandExample}>
                        <div className={Styles.CommandExampleLabel}>Examples</div>
                        <div className={Styles.CodeBlock} style={{ marginBottom: 8 }}>
                            <code># Print last 100 lines</code>
                            <br />
                            <code>modelpark logs myapp</code>
                        </div>
                        <div className={Styles.CodeBlock} style={{ marginBottom: 8 }}>
                            <code># Follow log output</code>
                            <br />
                            <code>modelpark logs myapp -f</code>
                        </div>
                        <div className={Styles.CodeBlock} style={{ marginBottom: 8 }}>
                            <code># Print last 50 lines</code>
                            <br />
                            <code>modelpark logs myapp -n 50</code>
                        </div>
                        <div className={Styles.CodeBlock}>
                            <code># Print last 50 lines and follow</code>
                            <br />
                            <code>modelpark logs myapp -n 50 -f</code>
                        </div>
                    </div>

                    <div className={Styles.CommandExample}>
                        <div className={Styles.CommandExampleLabel}>Output</div>
                        <div className={Styles.CodeBlock}>
                            <code>{`=== modelpark run started at 2026-02-12T10:30:00Z ===
INFO  tunnel connected  {"subdomain": "myapp"}
INFO  stream opened     {"remote": "203.0.113.5:4321"}`}</code>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
